import { actionType } from './action';
import { IAction } from '@interface/IAction';

export const InitialState = Object.freeze({
    subscribedAssetList: [],
    liveReceivableList: [],
    freeCashBalance: {},
    assetDetail: {},
    purchaseSubAsset: {
        assetId: undefined,
        keyFigure: []
    },
    isBuyNowModalInitialized: false,
    sellerKeyFigure: {
        assetId: undefined,
        keyFigure: []
    },
    sellerStats: {
        assetId: undefined,
        stats: []
    },
    sellerLiveAsset: [],
    sellerPreviousAsset: [],
    purchaseAssets: {
        isPurchasing: false,
        assetType: '',
        assetId: '',
        assetIds: [],
        result: { message: '' }
    },
    sellerReportPath: '',
    creditEnhancementMapping: {},
});


const reducer = (preState = InitialState, action: IAction) => {
    const { type, payload } = action;

    switch (type) {

        case actionType.SET_LIVE_RECEIVABLE_LIST:
            return {
                ...preState,
                liveReceivableList: payload
            };

        case actionType.SET_SUBSCRIBED_ASSET_TYPE:
            return {
                ...preState,
                subscribedAssetList: payload || []
            };

        case actionType.SET_PURCHASE_SUB_ASSETS:
            const { assetId, subAssetList } = payload;
            return {
                ...preState,
                purchaseSubAsset: {
                    assetId,
                    subAssetList
                }
            };

        case actionType.SET_BUY_NOW_MODAL_INITIALIZED:
            return {
                ...preState,
                isBuyNowModalInitialized: true
            }

        case actionType.CLOSE_BUY_NOW_MODAL:
            return {
                ...preState,
                isBuyNowModalInitialized: false,
                isOverConcentration: false,
                purchaseSubAsset: []
            }

        case actionType.SET_RECEIVABLE_DETAIL:
            return {
                ...preState,
                assetDetail: payload || {}
            }

        case actionType.SET_SELLER_KEY_FIGURE:
            return {
                ...preState,
                sellerKeyFigure: payload || {}
            }

        case actionType.SET_SELLER_STATS:
            return {
                ...preState,
                sellerStats: payload || {}
            }

        case actionType.SET_SELLER_PREVIOUS_ASSET:
            return {
                ...preState,
                sellerPreviousAsset: {
                    sellerId: payload.sellerId,
                    assets: payload.asset
                }
            };

        case actionType.SET_SELLER_LIVE_ASSET:
            return {
                ...preState,
                sellerLiveAsset: {
                    sellerId: payload.sellerId,
                    assets: payload.asset
                }
            }

        case actionType.SET_PURCHASE_ASSETS:
            return {
                ...preState,
                purchaseAssets: {
                    isPurchasing: true,
                    assetType: payload.assetType,
                    assetId: payload.assetId,
                    assetIds: payload.assetIds,
                    result: { message: '' }
                }
            }

        case actionType.SET_PURCHASE_ASSETS_CB:
            return {
                ...preState,
                purchaseAssets: {
                    isPurchasing: false,
                    assetType: '',
                    assetId: '',
                    assetIds: [],
                    result: payload
                }
            }

        case actionType.SET_PRE_SIGNED_SELLER_REPORT_URL:
            return {
                ...preState,
                sellerReportPath: payload
            }

        case actionType.RESET:
            return InitialState;
        
        case actionType.SET_CREDIT_ENHANCEMENT_MAPPING:
            return {
                ...preState,
                creditEnhancementMapping: payload
            };
            
        default:
            return preState;
    }
}

export default reducer;